import { Observable, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { makeStateKey, StateKey, TransferState } from '@angular/core';

export class TranslateBrowserLoader implements TranslateLoader {

    constructor(
        private readonly http: HttpClient,
        private readonly transferState: TransferState
    ) { }

    public getTranslation(lang: string): Observable<any> {

        const key: StateKey<any> =
            makeStateKey<any>('transfer-translate-' + lang);

        const data = this.transferState.get(key, null);

        if (data) {
            this.transferState.remove(key);
            return of(data);
        } else {
            return this.http.get(`/assets/i18n/${lang}.json`);
        }
    }
}

export function translateBrowserLoaderFactory(
    http: HttpClient,
    transferState: TransferState
) {
    return new TranslateBrowserLoader(http, transferState);
}